import type { AbstractControl, FormControl, FormGroup } from '@angular/forms';

export const noopFormGroupTransform = <T>(v: AbstractControl<Partial<T>, T>) => <
    FormGroup<{
      [K in keyof T]: FormControl<T[K]>;
    }>
  >v;
